import styled from 'styled-components';

export const NavigateMapContainer = styled.div`
	width: 100%;
	height: 100%;
	background: var(--ion-color-step-800);
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	position: relative;
`;

export const ControlsContainer = styled.div`
	position: absolute;
	bottom: 0;
	width: 100%;
	height: 88px;
	padding: 2rem;
	background-color: var(--ion-color-primary);
`;
